import { LOCATION_NEIGHBORHOOD } from '../../routes';
import customAxios from "../../customAxios";
import {locationNamespace} from "../../../types/location.namespace";

async function updateNeighborhood(_id: string, props: locationNamespace.neighborhood.update) {
  try {
    return (await customAxios.patch(`${LOCATION_NEIGHBORHOOD}/${_id}`, props)).data;
  } catch (error: any) {
    console.error({LOCATION_NEIGHBORHOOD: error});
  }
}

export default updateNeighborhood;
